import PropTypes from 'prop-types';
import React from 'react';
import PhaseType from 'types/phase';

export const floor_wizard = ({ event: { kind, data: { success } } }) =>
  <div className={kind}>
    {success && 'Phase information was successfully sent to Floor Wizard'}
    {!success && 'Phase information was not sent to Floor Wizard'}
  </div>;

floor_wizard.propTypes = {
  event: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    data: PropTypes.shape({
      success: PropTypes.bool,
    }).isRequired,
  }).isRequired,
  phase: PhaseType,
};



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/floor_wizard.jsx